// RentSearchResults.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RentCard from './RentCard'; // similar to PGCard but for rents
import apnagharLogo from './apnaghar.png';
import './PGListing.css';
import './SearchResults.css';

function RentSearchResults() {
  const navigate = useNavigate();
  const location = useLocation();
  const filteredRents = location.state?.filteredRents || []; // coming from RentListing filters

  const handleCardClick = (rent) => {
    navigate(`/rent/${rent.id}`);
  };

  return (
    <div className="search-results-page">
      {/* Header */}
      <button className="back-btn1" onClick={() => navigate(-1)}>← Back</button>
      <div className="search-header">
        <img src={apnagharLogo} alt="Logo" className="search-logo" />
        <h1 className="search-brand-name">ApkaGhr</h1>
      </div>

      {/* Search info */}
      <div className="search-info">
        {filteredRents.length > 0 ? (
          <h2>
            Showing <span className="highlight">{filteredRents.length}</span> results for your search
          </h2>
        ) : (
          <h2>
            Sorry, we couldn't find any rents matching your search criteria
          </h2>
        )}
        <p className="search-subtext">
          Discover premium, verified, and budget-friendly rental accommodations across Assam.
          Click on a listing to view more details and schedule your visit.
        </p>
      </div>

      {/* Rent Cards */}
      {filteredRents.length > 0 && (
        <div className="search-list">
          {filteredRents.map(rent => (
            <RentCard key={rent.id} rent={rent} handleClick={handleCardClick} />
          ))}
        </div>
      )}

      {/* No results message */}
      {filteredRents.length === 0 && (
        <div className="no-results-container">
          <p className="no-results-msg">😔 No rents match your filter. Try adjusting your filters or search again.</p>
          <button className="back-to-list-btn" onClick={() => navigate(-1)}>
            ← Go Back
          </button>
        </div>
      )}
    </div>
  );
}

export default RentSearchResults;
